{
  "id": "campaign-049",
  "name": "Neglected Acre",
  "seed": "campaign:49",
  "startDir": "E",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    ",,.....,RRRR",
    ",,.....,RRRR",
    ",,.....,____",
    ",#,...x,,,,,",
    "..u,u,,u,u,,",
    "..~.,,,,,,,,",
    "...~,,,,,,,,",
    "ffff,,ffffff",
    "...,,,,,,,,,",
    ",,u,,,,,,u,,",
    ",,,,,,,,,,,,",
    "ffffffff,,ff",
    ",,,,,,,,,,,,",
    ",cccc,,cccc,",
    ",,,,,,,,,,,,",
    "..,,,,,...,,",
    "S...,,,..x,,"
  ],
  "critters": [
    {
      "kind": "rabbit",
      "x": 6,
      "y": 0
    },
    {
      "kind": "squirrel",
      "x": 5,
      "y": 3
    },
    {
      "kind": "rabbit",
      "x": 8,
      "y": 15
    },
    {
      "kind": "rabbit",
      "x": 2,
      "y": 6
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 8,
      "y": 10
    },
    {
      "kind": "gas",
      "x": 7,
      "y": 5
    },
    {
      "kind": "coin",
      "x": 11,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 8,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 2,
      "y": 5
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 4
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 12
    },
    {
      "kind": "coin",
      "x": 4,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 1
    },
    {
      "kind": "repair",
      "x": 1,
      "y": 15
    }
  ],
  "generatorVersion": 3,
  "level": 49,
  "biome": "farm",
  "par": {
    "reel": 16242,
    "push": 9670,
    "selfPropelled": 8946,
    "tractor": 5405,
    "zeroTurn": 6141,
    "fairway": 4040
  },
  "routeTries": {
    "par": {
      "reel": 0,
      "push": 7,
      "selfPropelled": 21,
      "tractor": 9,
      "zeroTurn": 4,
      "fairway": 23
    }
  }
}
